import { SelectOption } from "./types";

export const OBJECT_LOCK_OPTIONS: SelectOption[] = [
  { label: "Off", value: "off" },
  { label: "30 days", value: "30" },
  { label: "60 days", value: "60" },
  { label: "90 days", value: "90" },
];

export const EXPORT_COLUMNS = ["name", "size", "objects", "location", "replicated", "properties", "created"] as const;
